import React from "react";
import { Activity, AlertTriangle } from "lucide-react";

const REASONS = {
  disabled: "pilote désactivé",
  out_of_window: "en dehors de la plage horaire",
  min_gap: "délai minimum entre deux envois",
  daily_cap: "quota journalier atteint",
  no_target: "aucun prospect à contacter",
  suppressed: "contact désinscrit",
  locked: "déjà en cours d'exécution",
};

const minutesAgo = (iso) => Math.round((Date.now() - new Date(iso).getTime()) / 60000);

const describe = (r) => {
  if (!r) return "";
  if (r.action === "send") return `email ${r.kind} envoyé à ${r.societe}`;
  if (r.action === "error") return `erreur : ${r.reason}`;
  if (r.action === "skip") return REASONS[r.reason] || r.reason;
  return "";
};

const AgentStatus = ({ job, cronConfigured }) => {
  if (!job?.at) {
    return (
      <div className="flex items-center gap-2 text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded-lg px-4 py-2.5 mb-5" data-testid="agent-status-never">
        <AlertTriangle size={15} /> L'agent n'a encore jamais tourné sur ce serveur.
      </div>
    );
  }
  const ago = minutesAgo(job.at);
  const stale = ago > 20;
  const cls = stale ? "text-red-700 bg-red-50 border-red-200" : "text-neutral-700 bg-white border-neutral-200";
  return (
    <div className={`flex flex-wrap items-center gap-x-2 gap-y-1 text-sm border rounded-lg px-4 py-2.5 mb-5 ${cls}`} data-testid="agent-status">
      {stale ? <AlertTriangle size={15} /> : <Activity size={15} className="text-emerald-600" />}
      <span className="font-semibold" data-testid="agent-status-last">
        Dernier passage de l'agent : {ago < 1 ? "à l'instant" : `il y a ${ago} min`}
      </span>
      <span className="text-neutral-500">({new Date(job.at).toLocaleString("fr-FR")}, via {job.via === "cron" ? "cron plateforme" : "planificateur interne"})</span>
      <span className="text-neutral-500" data-testid="agent-status-reason">— {describe(job.result)}</span>
      {stale && <span className="w-full text-xs">L'agent ne tourne plus : vérifiez le déploiement{cronConfigured ? "" : " et la clé WEBHOOK_CRON_SECRET"}.</span>}
    </div>
  );
};

export default AgentStatus;
